import React, { Dispatch, SetStateAction } from "react";

import {
  ButtonClose,
  CloseContainer,
  Container,
  Content,
  LinkTo,
  TextSubTitle,
  TextTitle,
  TextWrapper,
} from "./styles";

type ResetPasswordProps = {
  showModal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
};

const ResetPassword: React.FC<ResetPasswordProps> = ({
  showModal,
  setShowModal,
}) => {
  return (
    showModal && (
      <Container>
        <Content>
          <CloseContainer>
            <ButtonClose
              onClick={() => {
                setShowModal(false);
              }}
            >
              X
            </ButtonClose>
          </CloseContainer>
          <TextWrapper>
            <TextTitle>Sua senha expirou!</TextTitle>
            <TextSubTitle>
              Para a Ultragaz a Segurança sempre vem em primeiro lugar! Crie uma
              nova senha através do link{" "}
              <LinkTo to="/esqueci-senha-mi">Esqueci minha senha</LinkTo>
            </TextSubTitle>
          </TextWrapper>
        </Content>
      </Container>
    )
  );
};

export default ResetPassword;
